import { FC } from 'react'
import cx from 'classnames'

import { MediaProps } from '../Media'

import * as SC from './styled'

export type MediaListProps = {
  className?: string
  items: Array<MediaProps>
}

const MediaList: FC<MediaListProps> = ({ className, items }) => {
  return (
    <SC.List className={cx('MediaList', className)}>
      {items.map((item, idx) => (
        <SC.Item key={idx} {...item} />
      ))}
    </SC.List>
  )
}

export default MediaList
